module.exports = __webpack_public_path__ + "media/images/home/mini/screen_12-c23723ce2a612781cef3c50eb933dd11.png";